import styled from "styled-components";
import { Box } from "@mui/material";
import { VIEWER_COLORS, VIEWER_STYLE_CONSTANTS } from "./constants";

export const ViewerContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

export const StageContainer = styled.div`
  flex: 1;
  overflow: hidden;
  background-color: ${VIEWER_COLORS.BACKGROUND_LIGHT};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  min-height: 0;
`;

export const ControlsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${VIEWER_STYLE_CONSTANTS.CONTROLS_GAP}px;
  padding: ${VIEWER_STYLE_CONSTANTS.CONTROLS_PADDING}px;
  background-color: ${VIEWER_COLORS.WHITE};
  border-top: 1px solid ${VIEWER_COLORS.LIGHT_GRAY_BORDER};
  position: relative;
  z-index: 1;
`;

export const NavigationContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${VIEWER_STYLE_CONSTANTS.NAVIGATION_GAP}px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    gap: ${VIEWER_STYLE_CONSTANTS.NAVIGATION_GAP_MOBILE}px;
  }
`;

export const ThumbnailContainer = styled(Box)`
  display: flex;
  gap: ${VIEWER_STYLE_CONSTANTS.THUMBNAIL_GAP}px;
  overflow-x: auto;
  padding: ${VIEWER_STYLE_CONSTANTS.THUMBNAIL_PADDING_Y}px 0;

  &::-webkit-scrollbar {
    height: ${VIEWER_STYLE_CONSTANTS.THUMBNAIL_SCROLLBAR_HEIGHT}px;
  }

  &::-webkit-scrollbar-track {
    background: ${VIEWER_COLORS.SCROLL_TRACK};
    border-radius: ${VIEWER_STYLE_CONSTANTS.THUMBNAIL_SCROLLBAR_RADIUS}px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${VIEWER_COLORS.SCROLL_THUMB};
    border-radius: ${VIEWER_STYLE_CONSTANTS.THUMBNAIL_SCROLLBAR_RADIUS}px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: ${VIEWER_COLORS.SCROLL_THUMB_HOVER};
  }
`;

export const ThumbnailWrapper = styled.div<{ isActive: boolean }>`
  flex-shrink: 0;
  cursor: pointer;
  border: ${VIEWER_STYLE_CONSTANTS.THUMBNAIL_BORDER_WIDTH}px solid
    ${(props) =>
      props.isActive ? VIEWER_COLORS.PRIMARY_ORANGE : "transparent"};
  border-radius: ${VIEWER_STYLE_CONSTANTS.THUMBNAIL_BORDER_RADIUS}px;
  overflow: hidden;
  transition: border-color 0.2s;

  &:hover {
    border-color: ${(props) =>
      props.isActive
        ? VIEWER_COLORS.PRIMARY_ORANGE
        : VIEWER_COLORS.MEDIUM_GRAY_BORDER};
  }

  img {
    display: block;
    height: ${VIEWER_STYLE_CONSTANTS.THUMBNAIL_HEIGHT}px;
    width: auto;
    object-fit: contain;
  }
`;

export const SaveButtonContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${VIEWER_STYLE_CONSTANTS.SAVE_BUTTON_GAP}px;
`;
